// 任务状态
export enum TaskStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

// 任务步骤
export enum TaskStep {
  FETCHING_VIDEO = 'fetching_video',
  ASR_PROCESSING = 'asr_processing',
  TRANSLATING = 'translating',
  TTS_PROCESSING = 'tts_processing',
  VIDEO_SYNTHESIS = 'video_synthesis',
  UPLOADING = 'uploading',
  COMPLETED = 'completed',
}

// 视频来源类型
export enum VideoSource {
  DOUYIN = 'douyin',
  USER_UPLOAD = 'user_upload',
  URL_IMPORT = 'url_import',
}

// 任务接口
export interface Task {
  id: string;
  status: TaskStatus;
  currentStep: TaskStep;
  progress: number;
  source: VideoSource;
  sourceUrl?: string;
  sourceKeywords?: string[];
  createdAt: Date;
  updatedAt: Date;
  error?: string;
  result?: {
    finalVideoUrl?: string;
    tikTokVideoId?: string;
    tikTokUrl?: string;
  };
}

// 视频处理参数
export interface VideoProcessingParams {
  source: VideoSource;
  sourceUrl?: string;
  sourceKeywords?: string[];
  targetLanguage: 'ar-AE';
  enableSubtitles: boolean;
  enableTTS: boolean;
  tikTokCredentials?: TikTokCredentials;
}

// TikTok 凭证
export interface TikTokCredentials {
  accessToken: string;
  refreshToken?: string;
  accountId: string;
}

// 字幕条目
export interface SubtitleEntry {
  index: number;
  start: number; // 毫秒
  end: number; // 毫秒
  text: string;
}

// SRT 格式字幕
export interface SRTParseResult {
  entries: SubtitleEntry[];
  totalDuration: number;
}

// API 响应
export interface APIResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// 任务提交响应
export interface TaskSubmitResponse {
  taskId: string;
  status: TaskStatus;
  message: string;
}

// Firecrawl 响应
export interface FirecrawlResponse {
  success: boolean;
  data?: {
    content: string;
    markdown?: string;
    metadata?: {
      title?: string;
      description?: string;
      sourceURL?: string;
    };
  };
  error?: string;
}

// DeepSeek 翻译请求
export interface DeepSeekTranslationRequest {
  text: string;
  sourceLanguage: 'zh-CN';
  targetLanguage: 'ar-AE';
  context?: string;
}

// DeepSeek 翻译响应
export interface DeepSeekTranslationResponse {
  translatedText: string;
  confidence?: number;
  alternatives?: string[];
}

// TTS 请求
export interface TTSRequest {
  text: string;
  language: 'ar-AE';
  voice?: string;
  speed?: number;
  pitch?: number;
}

// TTS 响应
export interface TTSResponse {
  audioUrl: string;
  duration: number;
  format: string;
}